<template>
  <section class="section3-container">
    <div class="title-container pic-full" :class="lang"></div>
    <p class="desc" :class="lang">{{ homeLang.section3.desc }}</p>
    <div class="pic-container pic-full" ref="bscEthXswap">
      <div class="bsc-container pic-full"
           :class="{'bsc-rotate': bscRotate}"></div>
      <div class="eth-container pic-full"
           :class="{'eth-rotate': ethRotate}"></div>
      <div class="xswap-ring-container pic-full flex-center"
           :class="{'ring-rotate': ringRotate}">
        <div class="xswap-container pic-full"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "section3",
  data() {
    return {
      bscRotate: false,
      ethRotate: false,
      ringRotate: false
    }
  },
  props: {
    homeLang: {
      type: Object
    }
  },
  mounted() {
    window.addEventListener('scroll', ()=>{
      if (this.$refs.bscEthXswap &&
          document.documentElement.scrollTop + document.documentElement.clientHeight
          >= this.$refs.bscEthXswap.offsetTop + this.$refs.bscEthXswap.clientHeight) {
        this.bscRotate = true
        this.ethRotate = true
        setTimeout(()=>{
          this.ringRotate = true
        },150)
      }
    })
  }
}
</script>

<style lang="less">
@media screen and (min-width: 767px) {
  .section3-container {
    .title-container {
      &.zh {
        width: 4.57rem;
        height: 0.58rem;
        margin: 0.53rem auto 0;
        background-image: url("../../assets/pc/section3/title_zh.png");
      }
      &.en {
        width: 4.17rem;
        height: 0.96rem;
        margin: 0.56rem auto 0;
        background-image: url("../../assets/pc/section3/title.png");
      }
    }
    .desc {
      font-size: 0.2rem;
      font-family: PingFangSC, PingFangSC-Regular;
      text-align: center;
      color: #333333;
      line-height: 0.28rem;
      width: 9.47rem;
      margin: 0.36rem auto 0;
      &.zh {
        margin: 0.24rem auto 0;
      }
    }
    .pic-container {
      width: 9.39rem;
      height: 5.46rem;
      margin: 0.48rem auto 0;
      position: relative;
      >div {
        position: absolute;
      }
      .bsc-container {
        width: 5.15rem;
        height: 5.37rem;
        transform-origin: 83% 70%;
        background-image: url("../../assets/pc/section3/bsc.png");
        &.bsc-rotate {
          animation: bscRotate 0.3s 2;
          @keyframes bscRotate {
            0% {
              transform: rotate(0deg);
            }
            50% {
              transform: rotate(17deg);
            }
            100% {
              transform: rotate(0deg);
            }
          }
        }
      }
      .eth-container {
        width: 5.12rem;
        height: 5.46rem;
        transform-origin: 15% 73%;
        background-image: url("../../assets/pc/section3/eth.png");
        right: 0;

        &.eth-rotate {
          animation: ethRotate 0.3s 2;
          @keyframes ethRotate {
            0% {
              transform: rotate(0deg);
            }
            50% {
              transform: rotate(-17deg);
            }
            100% {
              transform: rotate(0deg);
            }
          }
        }
      }
      .xswap-ring-container {
        left: 3.6rem;
        top: 0.58rem;
        width: 1.98rem;
        height: 1.98rem;
        transform-origin: 50% 50%;
        background-image: url("../../assets/pc/section3/spin.png");
        &.ring-rotate {
          transform: rotate(360deg);
          transition: transform 0.45s;
        }
        .xswap-container {
          width: 1.68rem;
          height: 1.68rem;
          background-image: url("../../assets/pc/section3/xswap.png");
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .section3-container {
    .title-container {
      &.zh {
        width: 3.94rem;
        height: 0.5rem;
        background-image: url("../../assets/mobile/section3/title_zh.png");
        margin: 0.35rem auto 0;
      }
      &.en {
        width: 4.17rem;
        height: 0.96rem;
        background-image: url("../../assets/mobile/section3/title.png");
        margin: 0.44rem auto 0;
      }
    }
    .desc {
      font-size: 0.24rem;
      font-family: PingFangSC, PingFangSC-Regular;
      text-align: center;
      color: #333333;
      line-height: 0.33rem;
      width: 6.25rem;
      margin: 0.44rem auto 0;
      &.zh {
        margin: 0.26rem auto 0;
      }
    }
    .pic-container {
      width: 7.5rem;
      height: 4.29rem;
      margin: 0.23rem auto 0;
      position: relative;
      background-image: url("../../assets/mobile/section3/bscAndEth.png");
      .xswap-ring-container {
        position: absolute;
        left: 3.01rem;
        top: 0.52rem;
        width: 1.56rem;
        height: 1.47rem;
        background-image: url("../../assets/mobile/section3/spin.png");
        .xswap-container {
          width: 1.32rem;
          height: 1.33rem;
          background-image: url("../../assets/mobile/section3/xswap.png");
        }
      }
    }
  }
}
</style>
